import React from 'react'
import HrSection1 from '../Component/HRpublish/HrSection1'
import WhyHrmsNeed from '../Component/HRpublish/WhyHrmsNeed'
import BoostProductivity from '../Component/HRpublish/BoostProductivity'
import HrSection from '../Component/HRpublish/HrSection'
import WorkSamrter from '../Component/HRpublish/WorkSamrter'
import EasyToManage from '../Component/HRpublish/EasyToManage'
import ClientAboutUs from '../Component/HRpublish/ClientAboutUs'
import { Helmet } from 'react-helmet'
import HomeNavBar from '../Component/HomeComponent/HomeNavBar'
import WhoWeAre from '../Component/HRpublish/WhoWeAre'
import OurVision from '../Component/HRpublish/OurVision'
import WhatWeSolve from '../Component/HRpublish/WhatWeSolve'
import MeridaVision from '../Component/HRpublish/MeridaVision'
import DifferenceSection from '../Component/HRpublish/DifferentSection'
import OurApproach from '../Component/HRpublish/OurApproach'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import aboutBanner1 from '../Assest/cards/Merida.avif'
import aboutFooterCta from '../Assest/cards/about-footer-cta.avif'
import CTAButton from '../Component/CTAButton'

const HrmsPublish = () => {
    const navigate = useNavigate();
    return (
        <div>
            <Helmet>
                {/* Basic SEO */}
                <title>About Us | Merida HR Consulting</title>

                <meta
                    name="description"
                    content="Learn about Merida HR Consulting, our mission, vision, and how we help businesses grow through AI-powered recruitment, staffing, payroll, compliance, and workforce management solutions."
                />

                <link
                    rel="canonical"
                    href="https://www.meridahr.com/about"
                />

                <meta property="og:type" content="website" />
                <meta property="og:title" content="About Us | Merida HR Consulting" />
                <meta
                    property="og:description"
                    content="Learn about Merida HR Consulting and how we empower organizations with AI-powered HR, staffing, recruitment, payroll, and compliance solutions."
                />
                <meta
                    property="og:url"
                    content="https://www.meridahr.com/about"
                />
                <meta
                    property="og:image"
                    content="https://www.meridahr.com/images/about-banner.webp"
                />

                <meta name="twitter:card" content="summary_large_image" />

                {/* Organization */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        "@id": "https://www.meridahr.com/#organization",

                        name: "Merida HR Consulting",

                        url: "https://www.meridahr.com",

                        logo: {
                            "@type": "ImageObject",
                            "@id": "https://www.meridahr.com/#logo",
                            url: "https://www.meridahr.com/logo.avif",
                            contentUrl: "https://www.meridahr.com/logo.avif",
                            caption: "Merida HR Consulting"
                        },

                        image: {
                            "@id": "https://www.meridahr.com/#logo"
                        },

                        email: "meridahrconsulting@gmail.com",

                        telephone: "+91-8904599283",

                        address: {
                            "@type": "PostalAddress",
                            addressLocality: "Bengaluru",
                            addressRegion: "Karnataka",
                            addressCountry: "IN"
                        },

                        sameAs: [
                "https://www.facebook.com/MERIDAHRCONSULTING/",
                "https://www.linkedin.com/company/95719869/admin/dashboard/",
                "https://www.instagram.com/meridahrconsultancy/?hl=en",
                "https://www.youtube.com/@meridahrconsultancy5069"
            ],


                        contactPoint: [
                            {
                                "@type": "ContactPoint",
                                telephone: "+91-8904599283",
                                contactType: "Customer Support",
                                availableLanguage: [
                                    "English"
                                ]
                            }
                        ]
                    })}
                </script>

                {/* Website */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "WebSite",

                        "@id": "https://www.meridahr.com/#website",

                        url: "https://www.meridahr.com",

                        name: "Merida HR Consulting",

                        publisher: {
                            "@id": "https://www.meridahr.com/#organization"
                        },

                        inLanguage: "en-US",

                        potentialAction: {
                            "@type": "SearchAction",
                            target:
                                "https://www.meridahr.com/search?q={search_term_string}",
                            "query-input":
                                "required name=search_term_string"
                        }
                    })}
                </script>

                {/* About Page */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",

                        "@type": "AboutPage",

                        "@id": "https://www.meridahr.com/about",

                        url: "https://www.meridahr.com/about",

                        name: "About Merida HR Consulting",

                        description:
                            "Learn about Merida HR Consulting, our vision, mission, and expertise in recruitment, staffing, payroll, HR consulting, compliance, and workforce management.",

                        isPartOf: {
                            "@id": "https://www.meridahr.com/#website"
                        },

                        about: {
                            "@id": "https://www.meridahr.com/#organization"
                        },

                        publisher: {
                            "@id": "https://www.meridahr.com/#organization"
                        },

                        primaryImageOfPage: {
                            "@id":
                                "https://www.meridahr.com/about/#primaryimage"
                        },

                        image: {
                            "@id":
                                "https://www.meridahr.com/about/#primaryimage"
                        },

                        breadcrumb: {
                            "@id":
                                "https://www.meridahr.com/about/#breadcrumb"
                        },

                        inLanguage: "en-US",

                       

                        potentialAction: {
                            "@type": "ReadAction",
                            target: [
                                "https://www.meridahr.com/about"
                            ]
                        }
                    })}
                </script>

                {/* Primary Image */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",

                        "@type": "ImageObject",

                        "@id":
                            "https://www.meridahr.com/about/#primaryimage",

                        inLanguage: "en-US",

                        url:
                            "https://www.meridahr.com/images/about-banner.webp",

                        contentUrl:
                            "https://www.meridahr.com/images/about-banner.webp",

                        caption:
                            "Merida HR Consulting Team"
                    })}
                </script>

                {/* Breadcrumb */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",

                        "@type": "BreadcrumbList",

                        "@id":
                            "https://www.meridahr.com/about/#breadcrumb",

                        itemListElement: [
                            {
                                "@type": "ListItem",
                                position: 1,
                                name: "Home",
                                item: "https://www.meridahr.com/"
                            },
                            {
                                "@type": "ListItem",
                                position: 2,
                                name: "About Us",
                                item: "https://www.meridahr.com/about"
                            }
                        ]
                    })}
                </script>
            </Helmet>
            <div className="absolute w-full top-0 z-50">
                <HomeNavBar type='white' />
            </div>
            <HrSection1 />
            <WhoWeAre />

            <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
                className="container mx-auto px-6 mb-5"
            >
                <div className="w-full overflow-hidden rounded-[2.5rem] shadow-xl shadow-slate-100">
                    <img
                        src={aboutBanner1}
                        alt="About Banner"
                        className="w-full h-auto object-cover"
                    />
                </div>
            </motion.div>

            <div className="mb-24 flex justify-center">
                <CTAButton
                    text="Experience Transformation"
                    onClick={() => navigate('/contact')}
                    type="secondary"
                />
            </div>

            <OurVision />
            <WhatWeSolve />
            <MeridaVision />
            <DifferenceSection />
            <OurApproach />

            <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
                className="container mx-auto px-6 mb-5 mt-16"
            >
                <div className="w-full overflow-hidden rounded-[2.5rem] shadow-xl shadow-slate-100">
                    <img
                        src={aboutFooterCta}
                        alt="About Footer CTA"
                        className="w-full h-auto object-cover"
                    />
                </div>
            </motion.div>

            <div className="mb-24 flex justify-center">
                <CTAButton
                    text="Experience Transformation"
                    onClick={() => navigate('/contact')}
                    type="secondary"
                />
            </div>

            {/* <WhyHrmsNeed />
            <BoostProductivity />
            <HrSection />
            <WorkSamrter />
            <EasyToManage />
            <ClientAboutUs /> */}
        </div>
    )
}

export default HrmsPublish